import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgPercentageSign = (props, ref) => /* @__PURE__ */ jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx("rect", { x: 13, y: 13, width: 5, height: 5, rx: 2.5, stroke: "currentColor", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("rect", { x: 6, y: 6, width: 5, height: 5, rx: 2.5, stroke: "currentColor", strokeWidth: 2 }),
  /* @__PURE__ */ jsx("path", { d: "M6 18L18 6", stroke: "currentColor", strokeWidth: 2 })
] });
const ForwardRef = forwardRef(SvgPercentageSign);
export { ForwardRef as ReactComponent };
